import * as React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import connect from "nexia_mobile/flux_like/store/connect";
import AppState from "nexia_mobile/models/app_state";
import InternetRequiredPage from "nexia_mobile/components/Pages/InternetRequiredPage";

const InternetRequiredRoute = ({
  isNetworkConnected,
  appState,
  /* get all the forms of render which Route permits */
  render,
  component,
  children,
  /* ...as well as anything else a Route can use */
  ...providedProps
}) => (
  <Route
    // Now convert all the render behaviors into a function so we can insert
    // an InternetRequiredPage.
    render={(renderProps) => {
      if (!appState.inDemoMode && isNetworkConnected === false) {
        return <InternetRequiredPage />;
      } else if (component) {
        return React.createElement(component, renderProps);
      } else if (render) {
        return render(renderProps);
      } else if (typeof children === "function") {
        return children(renderProps);
      } else if (children != null) {
        return children;
      }
      throw new Error(
        `Attempted to render ${renderProps.location.pathname}, but was not provided a render, component, or children prop.`
      );
    }}
    {...providedProps}
  />
);
InternetRequiredRoute.propTypes = {
  isNetworkConnected: PropTypes.bool, // not required because undefined is allowed
  appState: PropTypes.instanceOf(AppState).isRequired,
  ...Route.propTypes,
};

export default connect(
  {
    isNetworkConnected: "isNetworkConnected",
    appState: "appState",
  },
  InternetRequiredRoute
);



// WEBPACK FOOTER //
// ./src/components/Routing/InternetRequiredRoute.jsx